import React, { useState, useEffect, useLayoutEffect } from "react";
import { useSelector } from "react-redux";
import http from "../../utils/http-common";
import GanttView from "../GanttChart";
import BaseLineView from "../GanttChart/BaseLineView";
import { setPlanForView } from "../../Slices/planslice";
import { useDispatch } from "react-redux";
import { useLocation, useOutletContext, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { TabContext, TabList, TabPanel } from '@mui/lab';
import ViewResource from "./Resource";
import { Box, Tab } from "@mui/material";
import Progress from "./Progress";
import IssueRegister from "./IssueRegister";
import Assumption from "./Assumption";
import RiskRegister from "./RiskRegister";
import Constraints from "./Constraints";
import Dependencies from "./Dependencies";

function ViewPlan(props) {
  const location = useLocation();
  const { drawerOpen } = useOutletContext();
  const initialTab = location.state?.tab || "ganttchart";
  const [value, setValue] = useState(initialTab);
const [isLoadingProject, setIsLoadingProject] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const searchParams = new URLSearchParams(location.search);
  const [isUpdating, setIsUpdating] = useState(false);
  const handleChange = async (event, newValue) => {
  setValue(newValue);
  const defaultOption = { key: "", label: "" }; // ✅ Default option always present

  try {
    if (newValue === "ganttchart") {
      // Refetch plan data to get updated resources
      await fetchPlanData();

      // Fetch resource mappings
      const responseData = await http.post(
        "master_service/plan_role/user/mapping/details",
        { plan_id: planData.plan_id }
      );

      if (responseData.data?.mappings?.length > 0) {
        // Map and filter valid users
        const fetchedResources = responseData.data.mappings
          .map((item) => {
            const key = item.user?.user_name || item.user?.email || "";
            const label = item.user?.user_name || item.user?.email || "";
            return key && label ? { key, label } : null;
          })
          .filter(Boolean);

        setResourceOptions([defaultOption, ...fetchedResources]);
      } else {
        setResourceOptions([defaultOption]);
      }
    }
  } catch (error) {
    console.error("Error fetching resources:", error);

    if (error.response?.status === 404) {
      console.warn("Error 404: No resources found for this plan.");
      setResourceOptions([defaultOption]); // ✅ Fallback to default
    } else {
      setResourceOptions([defaultOption]); // ✅ Fallback for any other error
    }
  }
};

  const urlid = searchParams.get("id");
  const [planId, setPlanId] = useState(() => localStorage.getItem("planId") || null);
  const userID = localStorage.getItem("user_id");
  useLayoutEffect(() => {
    fetchPlanDataparams(urlid);
  }, [urlid]);
  const [planName, setPlanName] = useState("");
  const { id, isEdit, isView, isDelete, table, isShare } = useSelector(
    (state) => state.planslice
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (isView && (id || planId)) {
      fetchPlanData();
    }
  }, [(id || planId), isView]);

  useEffect(() => {
    if (id) {
      setPlanId(id);
      localStorage.setItem("planId", id);
    }
  }, [id]);
  useLayoutEffect(() => {
    const storedId = localStorage.getItem("planId");
    if (storedId) {
      fetchPlanData(storedId);
    }
  }, []);

  const [planData, setPlanData] = useState([]);
  const fetchPlanData = async () => {
    try {
      setJsonData([]);
      const response = await http.get(`/master_service/get_plan/${id || planId}`);
      if (response.status === 200) {
        const data = response.data;

        setPlanData(data);
        localStorage.setItem("plan_id", data.plan_id);
        fetchJsonData(data);
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };

  const fetchPlanDataparams = async (urlid) => {
    try {
      setJsonData([]);
      // Check URL expiration
      const searchParams = new URLSearchParams(location.search);
      const expiryTimestamp = searchParams.get('expires');

      if (expiryTimestamp) {
        const expiryDate = new Date(decodeURIComponent(expiryTimestamp));
        const currentDate = new Date();

        if (currentDate > expiryDate) {
          //toast.error("Link has expired. Please request a new link.");
          navigate('/404');
          return;
        }
      }

      const token = localStorage.getItem("token");
      const response = await http.get(`/master_service/get_plan/${urlid}`, {
        headers: {
          Authorization: `${token}`,
        },
      });
      if (response.status === 200) {
        const data = response.data;
        // Check if end_date has passed
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0); // Reset time to start of day
        
        const endDate = data.end_date ? new Date(data.end_date) : null;
        if (endDate) endDate.setHours(0, 0, 0, 0); // Reset time if endDate exists
      
        const isLimitedAccess = data.access_name === "limited_access";
        const isUserInAccessList = data.plan_access_users?.some(
          (u) => u.user_id === userID
        );

        // if (currentDate > endDate) {
        //   navigate('/Expired');
        //   return;
        // }
        if (data.access_name === "full_access") {
          setPlanData(data);
          fetchJsonData(data);
          insertplan(data);
        } else if (isUserInAccessList) {
          //} else if (isLimitedAccess && isUserInAccessList) {
          // Allow limited access if user is in the plan_access_users list
          setPlanData(data);
          fetchJsonData(data);
          //insertplan(data);
        } else if (data.access_name === "full_access" && endDate && currentDate > endDate) {
          //} else if (!isLimitedAccess && endDate && currentDate > endDate) {
          // Only check expiry for non-limited access
          navigate("/Expired");
          return;
        } else {
          navigate('/Reg');
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        navigate('/404');
        } else {
        console.error("Error fetching plan data", error);
        setPlanData([]);
      }
    }
  };
  const insertplan = async (data) => {
    try {
      const token = localStorage.getItem("token");
      const response = await http.post(
        `/master_service/view/plan/access/data`,
        {
          plan_id: data.plan_id,
          user_id: data.user_id,
        }, {
        headers: {
          Authorization: `${token}`, // Pass the token in the Authorization header
        },
      }
      );
     } catch (error) {
      toast.error("Error inserting plan");
      console.error("Error fetching user data", error);
    }
  };
  const [jsonData, setJsonData] = useState([]);
  const [hasBaseline, setHasBaseline] = useState(false);
  const [resourceOptions, setResourceOptions] = useState([]);

const fetchJsonData = async (data) => {
  setIsLoadingProject(true);
const defaultOption = { key: "", label: "" };
  try {
    // 🔹 First: Try fetching plan data
    const response = await http.post(`/master_service/store-plan-data`, {
      plan_id: data.plan_id,
    });

    if (response.status === 200 || response.status === 201) {
      setJsonData(response.data?.data?.data?.tasks || []);
    } else if (response.status === 404) {
      setJsonData([]);
    }
  } catch (error) {
    console.error("Error fetching plan data:", error);
    setJsonData([]); // still clear tasks if plan API fails
  }

  // 🔹 Second: Always attempt mapping/details API, even if first one fails
  try {
    const responseData = await http.post(
      "master_service/plan_role/user/mapping/details",
      { plan_id: data.plan_id }
    );

     const fetchedResources =
      responseData.data?.mappings
        ?.map((item) => {
          const key = item.user?.user_name || item.user?.email || "";
          const label = item.user?.user_name || item.user?.email || "";
          return key && label ? { key, label } : null;
        })
        .filter(Boolean) || [];

    // ✅ Always include default option at top
    setResourceOptions([defaultOption, ...fetchedResources]);

  } catch (error) {
    if (error.response?.status === 404) {
      console.warn("No resources found for this plan.");
      setResourceOptions([]);
    } else {
      console.error("Error fetching resource mappings:", error);
      setResourceOptions([]);
    }
  } finally {
    setIsLoadingProject(false);
  }
};



  const [projectData, setProjectData] = useState(); // Assuming json is your initial data [json, setJson]
  const handleProjectDataUpdate = async (updatedData) => {
    if (isUpdating) return;
    setIsUpdating(true);
          const planID = localStorage.getItem('plan_id');
    try {
        // Single API call with debounced data
     const response = await http.post("/master_service/plan", {
          "plan_id": planID,
          "data": {
            "tasks": updatedData
          }
        });
        if (response.status === 200 || response.status === 201) {
      setJsonData(updatedData);
        }
      } catch (error) {
        console.error("Error adding new task:", error);
        setJsonData([]);
      } finally {
    setIsUpdating(false);
      }   
  };
  useEffect(() => {
    const checkHasBaseline = jsonData.some(
      task =>
        task.hasOwnProperty('BaselineStart') &&
        task.BaselineStart !== null &&
        task.BaselineStart !== ''
    );
    setHasBaseline(checkHasBaseline);
  }, [jsonData]);
  const handleNavigate = (path) => () => {
    navigate(path);

    if (isView) {
      dispatch(setPlanForView({ id: null, isView: false }));
    }
  };

  return (
    <div style={{ height: '100vh', overflow: 'hidden' }}>
      <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      fontFamily: "Inter, sans-serif",
      fontSize: "12px",
      fontWeight: 500,
      lineHeight: "20.52px",
      textAlign: "left",
      marginBottom: '5px',
      padding: '8px'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 180, width: '100%' }}>
      <div style={{marginTop: '-4px'}}>
        <span
          style={{ cursor: "pointer" }}
          onClick={handleNavigate("/home/myplans")}
        >
          My Plans
        </span> &gt; Plan:{planData?.plan_name}
      </div>

        </div>
      </div>
      <div style={{ height: 'calc(100vh - 40px)', // Adjust height to account for breadcrumb
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column' }}>
        <TabContext value={value}>
<Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 1 }}>
            <TabList
              onChange={handleChange} 
              aria-label="lab API tabs example"
              sx={{
          minHeight: 'unset',
          '& .MuiTab-root': {
            minHeight: 'unset',
            padding: '4px 10px',
            textTransform: 'capitalize',
            fontSize: '12px'
          }
        }}
            >
              <Tab label="Gantt Chart" value="ganttchart"/>              
              {userID === planData?.user_id && hasBaseline && <Tab label="Baseline" value="baseline" sx={{ textTransform: "capitalize" }} />}
              {userID === planData?.user_id && <Tab label="Resources" value="resources" sx={{ textTransform: "capitalize" }} />}
              {userID === planData?.user_id && <Tab label="Task Progress" value="progress" sx={{ textTransform: "capitalize" }} />}
              {userID === planData?.user_id && <Tab label="Issue Register" value="issue" sx={{ textTransform: "capitalize" }} />}
              {userID === planData?.user_id && <Tab label="Assumption" value="assumption" sx={{ textTransform: "capitalize" }} />}
              {userID === planData?.user_id && <Tab label="Risk Register" value="riskregister" sx={{ textTransform: "capitalize" }} />}
              {userID === planData?.user_id && <Tab label="Dependencies" value="dependencies" sx={{ textTransform: "capitalize" }} />}
              {userID === planData?.user_id && <Tab label="Constraints" value="constraints" sx={{ textTransform: "capitalize" }} />}
            </TabList>
        </Box>
          <TabPanel value="ganttchart" sx={{ 
            width: drawerOpen ? 'calc(100% - 10px)': '99%',
            transition: 'margin-left 0.3s, width 0.3s',
            height: '86vh', // Adjust to account for header and tabs
            p: '4px',
            overflowX: 'auto'
        }}>
            <GanttView projectData={jsonData} isLoadingProject={isLoadingProject} setIsLoadingProject={setIsLoadingProject} resourceOptions={resourceOptions} setResourceOptions={setResourceOptions} planData={planData} onProjectDataUpdate={handleProjectDataUpdate} />
          </TabPanel>
           <TabPanel value="baseline" sx={{ 
            width: drawerOpen ? 'calc(100% - 10px)': '99%',
            transition: 'margin-left 0.3s, width 0.3s',
            height: '86vh', // Adjust to account for header and tabs
            p: '4px',
            //overflowX: 'auto'
          }}>
            <BaseLineView projectData={jsonData} />
          </TabPanel>
          <TabPanel value="resources" sx={{ 
            padding: '2px', 
            width: drawerOpen ? 'calc(100% - 10px)': '99%',
            transition: 'margin-left 0.3s, width 0.3s',
            height: 'calc(100vh - 100px)',
            overflow: 'hidden'
          }}>
            <ViewResource />
          </TabPanel>
          <TabPanel value="progress" sx={{ 
            padding: '2px', 
            width: drawerOpen ? 'calc(100% - 10px)': '99%',
            transition: 'margin-left 0.3s, width 0.3s',
            height: 'calc(100vh - 100px)',
            overflow: 'hidden'
          }}>
            <Progress />
          </TabPanel>
          <TabPanel value="issue" sx={{ 
            padding: '2px', 
            width: drawerOpen ? 'calc(100% - 10px)': '99%',
            transition: 'margin-left 0.3s, width 0.3s',
            height: 'calc(100vh - 100px)',
            overflow: 'hidden'
          }}>
            <IssueRegister />
          </TabPanel>
          <TabPanel value="assumption" sx={{ 
            padding: '2px', 
            width: drawerOpen ? 'calc(100% - 10px)': '99%',
            transition: 'margin-left 0.3s, width 0.3s',
            height: 'calc(100vh - 100px)',
            overflow: 'hidden'
          }}>
            <Assumption />
          </TabPanel>
          <TabPanel value="riskregister" sx={{ 
            padding: '2px', 
            width: drawerOpen ? 'calc(100% - 10px)': '99%',
            transition: 'margin-left 0.3s, width 0.3s',
            height: 'calc(100vh - 100px)',
            overflow: 'hidden'
          }}>
            <RiskRegister />
          </TabPanel>
          <TabPanel value="dependencies" sx={{ 
            padding: '2px', 
            width: drawerOpen ? 'calc(100% - 10px)': '99%',
            transition: 'margin-left 0.3s, width 0.3s',
            height: 'calc(100vh - 100px)',
            overflow: 'hidden'
          }}>
            <Dependencies />
          </TabPanel>
          <TabPanel value="constraints" sx={{ 
            padding: '2px', 
            width: drawerOpen ? 'calc(100% - 10px)': '99%',
            transition: 'margin-left 0.3s, width 0.3s',
            height: 'calc(100vh - 100px)',
            overflow: 'hidden'
          }}>
            <Constraints />
          </TabPanel>
        </TabContext>
      </div>
    </div>
  );
}

export default ViewPlan;
